import projectService from '@/service/ProjectsService';
import Vue from 'vue';
const state = Vue.observable({
  projects: null,
  activeProject: null,
  isPictureLoading: false,
  currentProjectPicture: null,
  loadProjectPicture() {
    if (this.activeProject.ProjectPicture) {
      this.projectPicturePreview = this.activeProject.ProjectPicture;
      this.currentProjectPicture = this.projectPicturePreview;
    } else {
      this.isPictureLoading = true;
      projectService
        .getProjectPicture()
        .then(picture => {
          if (picture) {
            this.projectPicturePreview = Buffer.from(picture).toString();
            this.activeProject.ProjectPicture = this.projectPicturePreview;
            this.currentProjectPicture = this.projectPicturePreview;
          } else this.currentProjectPicture = null;
          this.isPictureLoading = false;
        })
        .catch(err => console.log(err));
      this.projectPicturePreview = null;
    }
  }
});
export default state;
